<template lang="pug">
	content-page(pagenav-icon="tune" )
		div(slot="nav")
			areas-filter-list(v-model="filterstring" hide-countries :show-map-button="!showMap" @map-button-click="showMap = true")
			navigation-default-list
		div
			h1 {{contentpage.name}}
			ws-content(:value="contentpage.content")
				travelbox.mb-6(:destination-slug="region.slug" destination-type="region")
				v-row.hidden-xs-only(no-gutters)
					v-col.font-weight-bold.text-no-wrap {{$tc('area_list.total_{count}', total)}}
					v-spacer
					areas-sort(v-model="sort")
						li(field="RELEVANCE") {{$t('area_list.sorting.relevance')}}
						li(field="NAME" ascending) {{$t('area_list.sorting.name')}}
						li(field="PISTES") {{$t('area_list.sorting.pistes')}}
						li(field="SNOW") {{$t('area_list.sorting.snow')}}
						li(field="MAXELEVATION") {{$t('area_list.sorting.maxelevation')}}
						li(field="RATING") {{$t('area_list.sorting.rating')}}
						li(:field="`DISTANCE_${$store.getters.preferedCity.toUpperCase()}`" ascending) {{$t('area_list.sorting.distance_{city}', {city: $store.getters.preferedCity.charAt(0).toUpperCase() + $store.getters.preferedCity.slice(1)})}}
				v-divider
				areas-map(:filterstring="`regions-${region.slug}:${filterstring}`" v-if="showMap")
				areas-list(:filterstring="`regions-${region.slug}:${filterstring}`" :sort="sort" :total.sync="total")
</template>

<script>
import gql from 'graphql-tag';
import AreasList from '@/components/areas/list.vue';
import AreasMap from '@/components/areas/map.vue';
import AreasSort from '@/components/areas/sort';
import AreasFilterList from '@/components/areas/filter-list.vue';
import NavigationDefaultList from '@/components/navigation-default-list';
import MetaFragment from '@/components/graphql/metaFragment.graphql';
import Travelbox from '@/components/travelbox.vue';
import Content from '@dengl/common/components/content.vue';

const getRegionPage = gql`
	query getRegionPage($slug: String, $path: String, $fallback: String) {
		region(slug: $slug) {
			id
			name
			slug
			country {
				id
				name
				slug
			}
		}
		contentpage(path: $path, fallback: $fallback) {
			id
			name
			slug
			content {
				...ContentDataFragment
			}
			...MetaFragment
		}
	}
	${MetaFragment}
	${Content.fragments}
`;

export default {
	name: 'AreasRegionRegion',
	nuxtI18n: {
		paths: {
			'nl-NL': '/skigebieden/regio/:region',
			'nl-BE': '/skigebieden/regio/:region',
			'de-DE': '/skigebiete/regionen/:region'
		}
	},
	components: {
		AreasList,
		AreasSort,
		AreasMap,
		'areas-filter-list': AreasFilterList,
		NavigationDefaultList,
		Travelbox
	},
	asyncData({ app, route, params }) {
		app.ads({});
		return app.$graphClient
			.query({
				query: getRegionPage,
				variables: {
					path: route.path,
					fallback: route.path.replace(params.area, '_region'),
					slug: params.region
				},
				errorPolicy: 'all'
			})
			.then(({ data, errors }) => {
				if (!data.contentpage) {
					return app.httpError(404, null, 'area-region-02', errors);
				}
				if (errors) {
					throw errors[0];
				}

				app.meta(data.contentpage.meta);
				app.breadcrumbs({
					[app.i18n.t(`page.areas:heading`)]: { name: 'areas' },
					[data.region.country.name]: {
						name: 'areas-countries-country',
						params: { country: data.region.country.slug }
					},
					[data.contentpage.name]: {
						name: 'areas-regions-region',
						params: { region: data.region.slug }
					}
				});

				return data;
			})
			.catch(app.$destinationNotFoundCatcher)
			.catch(error => {
				return app.httpError(500, null, 'areas-region-region-01', error);
			});
	},
	data() {
		return {
			filterstring: '',
			sort: {
				ascending: false,
				field: 'RELEVANCE'
			},
			total: null,
			showMap: false
		};
	},
	watch: {
		'$route.hash'() {
			this.filterstringFromHash();
		},
		filterstring(val) {
			window.location.hash = `#${val}`;
		}
	},
	mounted() {
		this.filterstringFromHash();
	},
	methods: {
		filterstringFromHash() {
			if (this.$route.hash) {
				this.filterstring = this.$route.hash.slice(1);
			}
		}
	},
	head() {
		return {
			...this.$structuredData()
		};
	}
};
</script>
